import React, { FC, useEffect, useState } from 'react'
import styles from './Awards.module.scss'
import { ScreenBreakPoint } from 'constants/index'
import { SlickSlider } from 'components/SlickSlider'

interface SlideProps {
	src: string
	alt?: string
}

interface AwardsProps {
	className?: string
}

const sliderSettings = {
	slidesToShow: 4,
	centerMode: true,
	autoplay: false,
	autoplaySpeed: 4000,
	speed: 500,
	responsive: [
		{
			breakpoint: ScreenBreakPoint.md,
			settings: {
				slidesToShow: 1,
				autoplay: true,
			},
		},
	],
}

export const sliderData = [
	{
		src: 'https://eightsleep.imgix.net/cover_mens_health.svg?v=1633020674',
		alt: 'Sleep Award 2021',
	},
	{
		src: 'https://eightsleep.imgix.net/gq_updated.svg?v=1666813547',
		alt: 'Fitness Award 2021 & 2022',
	},
	{
		src: 'https://eightsleep.imgix.net/Group_3486.svg?v=1636081952',
		alt: 'Best Inventions 2018 & 2019',
	},
	{
		src: 'https://eightsleep.imgix.net/innovation.svg?v=1647623247',
		alt: '2019 & 2022 Most Innovative Companies',
	},
]

const SlideContent = (props: SlideProps) => {
	return (
		<div className={styles.img_container}>
			<img
				src={props.src}
				alt={props.alt}
				loading="lazy"
			/>
		</div>
	)
}

export const Awards: FC<AwardsProps> = (props) => {
	const [mounted, setMounted] = useState(false)

	const items = sliderData.map((item) => ({
		component: (
			<SlideContent
				key={item.src}
				src={item.src}
				alt={item.alt}
			/>
		),
	}))

	useEffect(() => {
		setMounted(true)
	}, [])

	return (
		<section
			className={`${styles.section} ${props.className}`}
			id="awards-section"
		>
			<div className="bg-black">
				<div className={'max-1440'}>
					<SlickSlider
						settings={sliderSettings}
						className={`${styles.pro_slider} ${mounted ? styles.mounted : ''}`}
						items={items}
					/>
				</div>
			</div>
		</section>
	)
}
